import React, { lazy, Fragment, useMemo } from 'react';
import { connect } from 'react-redux';
import { Switch, Route } from 'react-router-dom';

import { getAuthorizedRouteList } from './appRouteList';
import { AppRoles, RouteListItem } from '../interfaces/authorizationInterfaces';
import AuthenticatedRoute from './authenticatedRoute';
import AppHeader from '../components/headers/appHeader';

const PageNotFound = lazy((): Promise<any> => { return import('../components/errors/pageNotFound'); });

interface PrivateRoutesProps {
    hasFetchedRoles: boolean;
    roles: AppRoles;
}

const PrivateRoutes: React.FC<PrivateRoutesProps> = (props: PrivateRoutesProps): JSX.Element => {
    const authorizedRoutes = useMemo(() => {
        if (props.hasFetchedRoles) {
            const allowedRoutes = getAuthorizedRouteList(props.roles);

            const allAuthorizedRoutes = allowedRoutes.map((route: RouteListItem): JSX.Element => {
                return (
                    <AuthenticatedRoute
                        path={route.path}
                        key={route.path}
                        exact
                        component={route.component}
                    />
                );
            });

            return allAuthorizedRoutes;
        }

        return <Fragment />;
    }, [props.hasFetchedRoles, props.roles]);

    if (props.hasFetchedRoles === false) {
        return <Fragment />;
    }

    return (
        <Fragment>
            <AppHeader renderFullHeader={true} />
            <Switch>
                {authorizedRoutes}
                <Route>
                    <PageNotFound />
                </Route>
            </Switch>
        </Fragment>
    );
};

const mapStateToProps = (state: any): object => {
    return {
        hasFetchedRoles: state.userDetails.hasFetchedRoles,
        roles: state.userDetails.roles
    };
};

const mergeProps = (stateProps: any, dispatchProps: any, ownProps: any): object => {
    return {
        ...ownProps,
        ...stateProps,
        ...dispatchProps
    };
};

export default connect(mapStateToProps, null, mergeProps)(PrivateRoutes);
